module.exports = __webpack_public_path__ + "static/report/img/w9.f0862e28.png";